import { SvgIcon, SvgIconProps } from "@mui/material";

const InfoIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <rect y="0.5" width="14" height="14" rx="4" fill="#EEEDFC"/>
        <path d="M6.4886 11V6.45455H7.49428V11H6.4886ZM6.99997 5.36364C6.80394 5.36364 6.63491 5.29688 6.49286 5.16335C6.35366 5.02983 6.28406 4.86932 6.28406 4.68182C6.28406 4.49432 6.35366 4.33381 6.49286 4.20028C6.63491 4.06676 6.80394 4 6.99997 4C7.19599 4 7.3636 4.06676 7.50281 4.20028C7.64485 4.33381 7.71588 4.49432 7.71588 4.68182C7.71588 4.86932 7.64485 5.02983 7.50281 5.16335C7.3636 5.29688 7.19599 5.36364 6.99997 5.36364Z" fill="currentColor"/>
    </SvgIcon>
);

export default InfoIcon;
